import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { CAPA_TYPES, CAPA_STATUS, isOverdue } from "../../lib/eightd";
import { Plus, Trash2, ListChecks, AlertTriangle } from "lucide-react";

// CAPA (corrective & preventive actions) tracker with owner, due date, status + overdue flag.
// items: [{ id?, type, description, owner_id, owner_name, due, status }]
export function CapaList({ items = [], onChange, owners = [], disabled }) {
  const ownerName = (id) => owners.find((o) => o.id === id)?.name || "";
  const patch = (i, p) => onChange(items.map((it, idx) => (idx === i ? { ...it, ...p } : it)));
  const add = () => onChange([...items, { type: "corrective", description: "", owner_id: null, owner_name: null, due: null, status: "open" }]);
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const openCount = items.filter((it) => it.status !== "done").length;
  const overdueCount = items.filter((it) => isOverdue(it.due, it.status)).length;

  return (
    <div data-testid="capa-panel">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-[#1B2A4A] flex items-center gap-1.5">
          <ListChecks className="h-3.5 w-3.5" />CAPA – Maßnahmen
          {openCount > 0 && <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-100">{openCount} offen</Badge>}
          {overdueCount > 0 && <Badge className="bg-red-100 text-red-700 hover:bg-red-100" data-testid="capa-overdue-badge"><AlertTriangle className="h-3 w-3 mr-1" />{overdueCount} überfällig</Badge>}
        </h3>
        {!disabled && (
          <Button size="sm" variant="outline" className="h-7 text-xs" onClick={add} data-testid="capa-add-btn">
            <Plus className="h-3 w-3 mr-1" />Maßnahme
          </Button>
        )}
      </div>
      {items.length === 0 && <p className="text-xs text-gray-400">Keine Maßnahmen erfasst.</p>}
      <div className="space-y-2">
        {items.map((it, i) => {
          const overdue = isOverdue(it.due, it.status);
          const [cls, lbl] = CAPA_STATUS[it.status] || CAPA_STATUS.open;
          return (
            <div key={it.id || i} data-testid={`capa-row-${i}`}
              className={`grid grid-cols-1 md:grid-cols-12 gap-2 items-center border rounded-lg p-2 ${overdue ? "border-red-200 bg-red-50/40" : "border-gray-100"}`}>
              <select data-testid={`capa-type-${i}`} disabled={disabled} value={it.type || "corrective"}
                onChange={(e) => patch(i, { type: e.target.value })}
                className="md:col-span-2 h-8 text-xs border border-gray-200 rounded-md px-2 bg-white text-gray-600 disabled:opacity-60">
                {CAPA_TYPES.map((tp) => <option key={tp.key} value={tp.key}>{tp.label}</option>)}
              </select>
              <Input data-testid={`capa-desc-${i}`} disabled={disabled} className="md:col-span-4 h-8 text-xs" placeholder="Maßnahme…"
                value={it.description || ""} onChange={(e) => patch(i, { description: e.target.value })} />
              <select data-testid={`capa-owner-${i}`} disabled={disabled} value={it.owner_id || ""}
                onChange={(e) => patch(i, { owner_id: e.target.value || null, owner_name: ownerName(e.target.value) || null })}
                className="md:col-span-2 h-8 text-xs border border-gray-200 rounded-md px-2 bg-white text-gray-600 disabled:opacity-60">
                <option value="">Verantwortlich…</option>
                {owners.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
              </select>
              <input type="date" data-testid={`capa-due-${i}`} disabled={disabled} value={(it.due || "").slice(0, 10)}
                onChange={(e) => patch(i, { due: e.target.value || null })}
                className={`md:col-span-2 h-8 text-xs border rounded-md px-2 bg-white disabled:opacity-60 ${overdue ? "border-red-300 text-red-600" : "border-gray-200 text-gray-600"}`} />
              <div className="md:col-span-2 flex items-center gap-1.5">
                <select data-testid={`capa-status-${i}`} disabled={disabled} value={it.status || "open"}
                  onChange={(e) => patch(i, { status: e.target.value })}
                  className="h-8 text-xs border border-gray-200 rounded-md px-2 bg-white text-gray-600 flex-1 disabled:opacity-60">
                  {Object.keys(CAPA_STATUS).map((k) => <option key={k} value={k}>{CAPA_STATUS[k][1]}</option>)}
                </select>
                {!disabled && <button onClick={() => remove(i)} data-testid={`capa-remove-${i}`} className="text-gray-400 hover:text-red-600"><Trash2 className="h-3.5 w-3.5" /></button>}
              </div>
              <div className="md:hidden"><Badge className={cls}>{lbl}</Badge></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
